import { render, staticRenderFns } from "./InfoDetailsXharra.vue?vue&type=template&id=1d49558e&scoped=true"
var script = {}
import style0 from "./InfoDetailsXharra.vue?vue&type=style&index=0&id=1d49558e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d49558e",
  null
  
)

export default component.exports